import AbstractIceContentController from '../../../abstract/ice-content/controller';

class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);
        this.init(widget);
        this.email = "";
        this.referenceId = "";
    }
    init(widget) {
        const widgetContext = $(widget.htmlNode);
        const successPage = decodeURI(widget.getPreference('successPage'));
        const screenName = "DOWNLOAD";
        var currentMainSection = $(".widget-dfa-download", widgetContext).closest("div[id^=step-]");
        var currentSubContainer = $(".widget-dfa-download", widgetContext).closest("div[id^=sub-step-]");
        var currentStep = currentMainSection.attr("id");
        var currentSubStep = currentSubContainer.attr("id");

        var screenData = {
            name: screenName,
            values: {
                container: "#" + currentStep + ">.bp-area>#" + currentSubStep,
                fieldValue: ""
            }
        };

        App.PubSub.subscribe("digitalApplicationData", (data) => {
            this.referenceId = data.referenceId;
        });

        $(".screenContinue", widgetContext).click(() => {
            App.PubSub.publish("digitalApplicationForm", screenData);
            let _email = $(".widget-form-section2 input[name='email']").val();
            const email = _email.replace(/^(.)(.*)(.@.*)$/,
                (_, a, b, c) => a + b.replace(/./g, '*') + c);
            if (email && this.referenceId) {
                sessionStorage.setItem("successDetails", JSON.stringify({ email, referenceId: this.referenceId }));
            }
        });

        App.PubSub.subscribe("fileToDownload", (data) => {
            
            const downloadUrl = "digitalApplication/download?referenceId=";
            $("#btnDownload", widgetContext).attr("download", "uitfform.pdf");
            $("#btnDownload", widgetContext).attr("target", "_blank");
            $("#btnDownload", widgetContext).attr("href", `${window.location.href.indexOf('localhost') > -1 ? '/portalserver/' : '/'}${downloadUrl}${this.referenceId}`);

            $("#btnDownload", widgetContext).click(() => {
                setTimeout(() => {
                    location.replace(`${window.location.href.indexOf('localhost') > -1 ? '/portalserver/' : '/'}${successPage}`);
                }, 5000);
            });

        });

        // $("#btnDownload", widgetContext).attr("href", "http://localhost:7777/portalserver/static/features/%5BBBHOST%5D/theme-default/assets/amtc-summary.pdf");

    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-form-sections/widget-dfa-download/scripts/controller.js